import React, { useEffect, useRef, useState } from "react";
import { isMobile } from "react-device-detect";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import { getStationUrl } from "../../../../helpers";
import { gtag, numberCommaString } from "helpers";
import { Controller, Navigation, Pagination, Scrollbar } from "swiper";
import PrintDate from "components/boards/common/PrintDate";
import Nickname from "components/contents/Nickname";
import HomePinSection from "pages/station/home/section/HomePinSection";

import { useSelector, useDispatch } from "react-redux";

const BoardSection = ({ title = "게시글", loading = false, boards = [], onDestroyPin = {}, onTabCange }) => {
    const sectionRef = useRef(null);

    const dispatch = useDispatch();

    const [ictOpen, setIctOpen] = useState(false);

    const { open } = useSelector(({ homeIctMenuReducer }) => ({
        open: homeIctMenuReducer.open,
    }));

    useEffect(() => {
        if (isMobile && sectionRef.current) {
            sectionRef.current.addEventListener(
                "touchstart",
                (event) => {
                    event.stopPropagation();
                },
                false,
            );
        }
    }, [sectionRef]);

    const prefBtnRef = useRef(null);
    const nextBtnRef = useRef(null);

    const swiperSettings = {
        className: "sct-board wrap3",
        slidesPerView: isMobile ? 1 : 3,
        modules: [Controller, Navigation, Scrollbar, Pagination],
        wrapperTag: "section",
        spaceBetween: 18,
        navigation: { // 네비게이션 적용, < >
            prevEl: prefBtnRef.current,
            nextEl: nextBtnRef.current,
        },
        pagination: { clickable: true, el: '.swiper-pagination', type: 'bullets' },
    }

    const handleMovePostPage = (titleNo) => {
        window.location.href = `${global.bj_id}/post/${titleNo}`;
        return;
    }

    const handleSwiperMoveButton = (event) => {
        event.stopPropagation();

        dispatch({type: 'ICT_CLOSE_MODAL'});
        dispatch({type: 'LATER_CLOSE_MODAL'});

    }

    if (isMobile) {
        if (boards.length > 0) {
            return (
                <>
                    <h2 className="ic-board" onClick={gtag('home', 'broad')}><a href={`${global.bj_id}/posts`}>{title}</a></h2>
                    <section className="sct-board">
                        <div data-type="scroll-horizon">
                            {boards.map((post, index) => {
                                return (
                                    <div className={`board-box ${post?.is_pin ? 'pinBox': ''}`} key={`home_board_${index}`}>
                                        <div className="info_wrap">
                                            <a href={`${getStationUrl(post?.user_id || "")}`} target={'_blank'} className="thumb" style={{ backgroundImage: `url(${post?.profile_image || ""})` }}></a>
                                            <div className="info">
                                                <Nickname item={post} offsetY={10}>
                                                    <p>
                                                        {post?.user_nick}
                                                    </p>
                                                </Nickname>
                                                <div className="date">
                                                    <PrintDate tag="span" target={post?.reg_date} />
                                                </div>

                                            </div>

                                            {post?.is_pin && <HomePinSection pinItem={post} boardTypeName={'게시글'} onDestroyPin={onDestroyPin}/>}
                                        </div>
                                        <div className="cont_wrap" onClick={() => handleMovePostPage(post?.title_no)}>
                                            <div className="txt_box">
                                                <div className="title">
                                                    {post?.is_notice && (<span className="noti">공지</span>)}
                                                    {post?.title_name}
                                                </div>
                                                <div className="detail"><p>{post?.content}</p></div>
                                            </div>
                                            {post?.thumb && <span className="thumb">
                                                <img src={`${post?.thumb}`} alt="" />
                                            </span>}
                                        </div>
                                        <div className="detail_wrap">
                                            <span className="view">{numberCommaString(post?.count?.read_cnt || 0)}</span>
                                            <span className="comment">{numberCommaString(post?.count?.comment_cnt || 0)}</span>
                                        </div>
                                    </div>)
                            })}
                        </div>
                    </section>
                </>
            );
        } else {
            return null;
        }
    }

    return (
        boards.length > 0 ? (
            <div className="brd_list_wrap">
                <h3 className="ic brd" onClick={gtag('home', 'broad')}><a href={`${global.bj_id}/posts`}>{title}</a></h3>
                <section className="sct-board wrap3 swiper-initialized swiper-horizontal swiper-pointer-events">
                    <Swiper
                        {...swiperSettings}
                    >
                        {boards.map((post, index) => {
                            return (
                                <SwiperSlide tag={'div'} className={`board-box ${post?.is_pin ? 'pinBox' : ''}`} key={`home_board_${index}`}>
                                    <>
                                        <div className="info_wrap">
                                            <div className="author">
                                                <a href={`javascript:;`} >
                                                    <span className="thumb" style={{ backgroundImage: `url(${post?.profile_image || ""})` }} onClick={(e) => {
                                                        e.preventDefault();
                                                        window.open(getStationUrl(post?.user_id || ""));
                                                    }} />
                                                    <span className="nick"
                                                        onClick={(event) => {
                                                            event.preventDefault();
                                                            event.stopPropagation();

                                                            if (ictOpen && open) {
                                                                dispatch({type: 'ICT_CLOSE_MODAL'});
                                                                dispatch({type: 'LATER_CLOSE_MODAL'});
                                                                setIctOpen(false);
                                                                return;
                                                            }
                                                            dispatch({type: 'ICT_CLOSE_MODAL'});
                                                            dispatch({type: 'LATER_CLOSE_MODAL'});

                                                            if (event && event.target) {
                                                                const { top, left, bottom } = event.target.getBoundingClientRect();
                                                                let newTop = top + window.scrollY;
                                                                let newLeft = left + window.scrollX;
                                                                setIctOpen(true);
                                                                dispatch({
                                                                    type: "ICT_OPEN_MODAL",
                                                                    payload: {
                                                                        item: post,
                                                                        top: (newTop + 25),
                                                                        left: newLeft,
                                                                        children: event.target,
                                                                    },
                                                                });
                                                            }
                                                        }}
                                                    >
                                                        {post?.user_nick}
                                                    </span>
                                                </a>
                                            </div>
                                            <div className="date">
                                                <PrintDate tag="span" target={post?.reg_date} />
                                            </div>
                                            {post?.is_pin && <HomePinSection pinItem={post} className='pin' onDestroyPin={onDestroyPin} boardTypeName={'게시글'} />}
                                        </div>
                                        <div className="cont_wrap" onClick={() => {
                                            handleMovePostPage(post?.title_no);
                                        }}>
                                            <div className="txt_box">
                                                <div className="title">
                                                    {post?.is_notice && <span className="noti">공지</span>}
                                                    {post?.title_name || ''}
                                                </div>
                                                <div className="detail">
                                                    <p>{post?.content || ''}</p>
                                                </div>
                                            </div>
                                            {post?.thumb && <span className="thumb">
                                    <img src={`${post?.thumb}`} alt="" />
                                </span>}
                                        </div>
                                        <div className="detail_wrap">
                                            <span
                                                className="view">{numberCommaString(post?.count?.read_cnt || 0)}</span>
                                            <span
                                                className="comment">{numberCommaString(post?.count?.comment_cnt || 0)}</span>
                                        </div>
                                    </>
                                </SwiperSlide>
                            );
                        })}

                    </Swiper>
                </section>
                <button type="button" ref={prefBtnRef} onClick={handleSwiperMoveButton} className="brd_prev">
                    이전
                </button>
                <button type="button" ref={nextBtnRef} onClick={handleSwiperMoveButton} className="brd_next">
                    다음
                </button>
            </div>

        ) : null
    )
}

export default BoardSection;
